import graphicsSrc from "@/assets/connect-to-scm-showcase-graphics.svg";

export function ConnectToScmShowcase() {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center p-4">
            <img
                src={graphicsSrc}
                alt="Graphics for keeping momentum on any device"
                className="mb-6 max-h-[75%] w-auto select-none object-contain"
            />
            <p className="mb-2 text-center text-3xl font-medium text-white drop-shadow-sm">Keep momentum on any device</p>
            <p className="max-w-lg text-center text-lg text-white/90 drop-shadow-sm">
                Transition seamlessly between Ona&#x2019;s conversational interface, native VS Code in the browser or
                any desktop IDE.
            </p>
        </div>
    );
}
